module.exports = __webpack_public_path__ + "static/media/quadro1.83cbdbd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/quadro1.png
// module id = 53
// module chunks = 0